import { JobMatchMeetingsFeedbackModalComponent } from "./jobMatchMeetingsFeedbackModal/job-match-meetings-feedback-modal.component";
import { JobMatchMeetingsComponent } from "./job-match-meetings.component";
export const JobMatchMeetingsModule = angular
    .module('jobMatchMeetings', [])
    .component(JobMatchMeetingsComponent.selector, JobMatchMeetingsComponent.component)
    .component(JobMatchMeetingsFeedbackModalComponent.selector, JobMatchMeetingsFeedbackModalComponent.component)
    .name;
//# sourceMappingURL=job-match-meetings.module.js.map